import { instance } from "../../../api";
import { MediaResponse } from "../../../models/media-model";

const apiToken = process.env.REACT_APP_API_TOKEN;

function dataUrlToBlob(dataUrl: string): Blob {
  const [header, base64 = ""] = dataUrl.split(",");
  const mimeMatch = header.match(/data:(.*?);/);
  const mime = mimeMatch?.[1] ?? "application/octet-stream";
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new Blob([bytes], { type: mime });
}

function extensionFromMime(mime: string): string {
  if (mime.includes("svg")) return "svg";
  if (mime.includes("png")) return "png";
  if (mime.includes("jpeg") || mime.includes("jpg")) return "jpg";
  if (mime.includes("webp")) return "webp";
  return "bin";
}

export async function uploadDataUrlImage(
  dataUrl: string,
  filenameBase: string,
): Promise<number | undefined> {
  if (!dataUrl.startsWith("data:")) {
    return undefined;
  }

  const blob = dataUrlToBlob(dataUrl);
  const ext = extensionFromMime(blob.type);
  const formData = new FormData();
  formData.append("files", blob, `${filenameBase}.${ext}`);

  const { data } = await instance.post<MediaResponse[]>("/api/upload", formData, {
    headers: {
      Authorization: `Bearer ${apiToken}`,
      "Content-Type": "multipart/form-data",
    },
  });

  const uploaded = Array.isArray(data) ? data[0] : data;
  return uploaded?.id;
}
